// extracted by mini-css-extract-plugin
export default {"section":"WelcomeSection_section__LH9Q0","section__contentSide":"WelcomeSection_section__contentSide__JsOVM","section__imageSide":"WelcomeSection_section__imageSide__N6kHV"};